import { fork } from 'redux-saga/effects';
import authSaga from './auth/saga';

function* rootSaga() {
  yield fork(authSaga);
  // ...more
}

export { rootSaga };
